"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var UsrAdminAccessAffilatesList = /** @class */ (function (_super) {
    __extends(UsrAdminAccessAffilatesList, _super);
    function UsrAdminAccessAffilatesList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [{
                title: 'Аффилейт шлюз',
                dataIndex: _this.props.dataAccess.dk_gws_affilate_title,
                key: _this.props.dataAccess.dk_gws_affilate_title,
                width: 200
            }, {
                title: 'Предоставил доступ',
                dataIndex: _this.props.dataAccess.dk_grant_admin_login,
                key: _this.props.dataAccess.dk_grant_admin_login,
                width: 200
            }, {
                title: 'Дата предоставления доступа',
                dataIndex: _this.props.dataAccess.dk_date_added,
                key: _this.props.dataAccess.dk_date_added,
                width: 200
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteAccessClick(record); } }))); },
                width: 110
            }];
        return _this;
    }
    UsrAdminAccessAffilatesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_A = this.props.dataAccess.Subscribe("*", function (id, data) {
            _this.setState({
                dataView: data.data,
                totalRows: data.total
            });
        });
        this.SID_L = this.props.availList.Subscribe("*", function (id, data) {
            _this.setState({
                dataAvail: data.data,
            });
        });
        this.setState({
            dataView: [],
            totalRows: 0,
            dataAvail: [],
            pageNum: 0,
            pageSize: this.props.state.UITablePageSize
        }, function () {
            _this.props.dataAccess.LoadDataByObtainAdminId(_this.props.recordKey);
        });
        this.props.availList.LoadData();
    };
    UsrAdminAccessAffilatesList.prototype.componentWillUnmount = function () {
        this.props.dataAccess.UnSubscribe(this.SID_A);
        this.props.availList.UnSubscribe(this.SID_L);
    };
    UsrAdminAccessAffilatesList.prototype.onDeleteAccessClick = function (record) {
        this.props.dataAccess.DoDeleteAccess(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0430\u0444\u0444\u0438\u043B\u0435\u0439\u0442 \u0448\u043B\u044E\u0437\u0443 ",
                React.createElement("b", null,
                    "[",
                    record.gws_affilate_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u043A\u0440\u044B\u0442"));
        });
    };
    UsrAdminAccessAffilatesList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.dataAccess.LoadDataByObtainAdminId(this.props.recordKey);
        }
        if (action === "create") {
            this.props.dialog
                .SetOnCloseClick(function () { _this.props.dialog.Close(); })
                .SetReLoadButtonVisible(true)
                .SetOnReLoadData(function () {
                _this.props.availList.LoadData(function () {
                    _this.props.dialog.SetViewData(_this.props.availList.GetData().data);
                });
            })
                .SetTitle("Выберите емэйл шлюз")
                .SetViewData(this.state.dataAvail)
                .SetOnSelectClick(function (key, val) {
                _this.props.dataAccess.DoAddAccess(key, _this.props.recordKey, function () {
                    _this.props.dialog.Close();
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0430\u0444\u0444\u0438\u043B\u0435\u0439\u0442 \u0448\u043B\u044E\u0437\u0443 ",
                        React.createElement("b", null,
                            "[",
                            val,
                            "]"),
                        " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D"));
                });
            })
                .Show();
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    UsrAdminAccessAffilatesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.dataView, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u0412\u0441\u0435\u0433\u043E : ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            "[",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0428\u043B\u044E\u0437:"),
                            "[",
                            record.gws_affilate_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u043E\u0441\u0442\u0443\u043F \u043F\u043E\u043B\u0443\u0447\u0438\u043B:"),
                            "[",
                            record.obtain_admin_login,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u043E\u0441\u0442\u0443\u043F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043B:"),
                            "[",
                            record.grant_admin_login,
                            "]")));
                } })));
    };
    return UsrAdminAccessAffilatesList;
}(React.Component));
exports.default = UsrAdminAccessAffilatesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_admins_list/ui/component/access/UsrAdminAccessAffilatesList.tsx
// module id = 1897
// module chunks = 0